<div
  class="search-widget-field-group dates-container"
  *appLet="{
    isWeb: isWeb$ | async,
    useMobileStyling: useMobileStyling$ | async
  } as $comp"
>
  <form *ngIf="datesFormGroup" [formGroup]="datesFormGroup">
    <div class="row">
      <div
        [ngClass]="{
          col: true,
          'col-6': tripType === tripTypeEnum.roundTrip
        }"
      >
        <label for="{{ group }}-departDate" (click)="depart.toggle($event)">{{
          cmsEntries.departDate
        }}</label>
        <div class="pointer">
          <app-date-picker
            #depart
            id="departDate"
            name="departDate"
            [group]="group"
            [minDate]="minDate"
            [maxDate]="maxDate"
            [datesEnabled]="departDates"
            [dateClasses]="departDateClasses"
            [control]="departDateControl"
            [value]="departDateControl?.value"
            [format]="format"
            [isAnimated]="true"
            [adaptivePosition]="
              ($comp.isWeb && !$comp.useMobileStyling) ?? true
            "
            placement="bottom"
            extraClasses="left"
            noLabel
            required
          ></app-date-picker>
        </div>
      </div>
      <div class="col-6 return" *ngIf="tripType === tripTypeEnum.roundTrip">
        <label for="{{ group }}-returnDate" (click)="return.toggle($event)">{{
          cmsEntries.returnDate
        }}</label>
        <div class="pointer">
          <app-date-picker
            #return
            id="returnDate"
            name="returnDate"
            [group]="group"
            [minDate]="depart.value"
            [maxDate]="maxDate"
            [datesEnabled]="returnDates"
            [dateClasses]="returnDateClasses"
            [control]="returnDateControl"
            [value]="returnDateControl?.value"
            [format]="format"
            [adaptivePosition]="
              ($comp.isWeb && !$comp.useMobileStyling) ?? true
            "
            placement="bottom"
            extraClasses="right"
            noLabel
            required
          ></app-date-picker>
        </div>
      </div>
    </div>
  </form>
</div>
